<template>
  <div class="q-mt-md">
    <DataTable
      name="notificationSettingTable"
      :data="tableData"
      :columns="columns"
      :columnItems="columnItems"
      rowKey="id"
      :filter-placeholder="$t('Search for alerts')"
    >
      <template v-slot:body-cell-accounts="{ props }">
        <Td :props="props">
          <template v-for="account in props.row.accounts">
            <span :key="account.id + 'span'">{{ account.name }}</span>
            <br :key="account.id + 'br'" />
          </template>
        </Td>
      </template>
      <template v-slot:body-cell-channels="{ props }">
        <Td :props="props">
          <template v-for="channel in props.row.channels">
            <span :key="channel.id + 'span'">{{ channel.name }}</span>
            <br :key="channel.id + 'br'" />
          </template>
        </Td>
      </template>
      <template v-slot:body-cell-actions="{ props }">
        <Td :props="props">
          <Button
            icon="edit"
            flat
            @click="$emit('openEditModal', 'edit', getAlert(props.row.id))"
          />
          <Button icon="delete" flat @click="$emit('openModal', props.row.id)" />
        </Td>
      </template>
    </DataTable>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Badge from '@design-system/components/Badge';
import Button from '@design-system/components/Button';
import DataTable from '@design-system/components/DataTable/DataTable';
import Td from '@design-system/components/DataTable/Td';

const messages = {
  en: {
    'Search for alerts': 'Search for alerts',
    Name: 'Name',
    Format: 'Format',
    To: 'To',
    Status: 'Status',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    Edit: 'Edit',
    Channels: 'Channels',
    Daily: 'Daily',
    'Daily Rate': 'Daily Rate',
    Monthly: 'Monthly',
    Actions: 'Actions',
  },
  ja: {
    'Search for alerts': 'アラートを検索する',
    Name: '名前',
    Format: 'フォーマット',
    To: '宛先',
    Status: 'ステータス',
    Enabled: '有効',
    Disabled: '無効',
    Edit: '変更する',
    Channels: 'チャンネル',
    Daily: '日次',
    'Daily Rate': '前日比',
    Monthly: '月次',
    Actions: 'アクション',
  },
};

export default {
  name: 'AlertsTable',
  i18n: { messages },
  components: {
    Badge,
    Button,
    DataTable,
    Td,
  },
  props: {
    tableData: Array,
  },
  computed: {
    ...mapState('notificationSettings', {
      alerts: state => state.alerts,
    }),

    columnItems() {
      return [
        { label: this.$t('Accounts'), key: 'accounts', visible: true },
        { label: this.$t('Channels'), key: 'channels', visible: true },
        { label: this.$t('Daily'), key: 'daily', visible: true },
        { label: this.$t('Daily Rate'), key: 'dailyRate', visible: true },
        { label: this.$t('Monthly'), key: 'monthly', visible: true },
        { label: this.$t('Actions'), key: 'actions', visible: true },
      ];
    },

    columns() {
      const columns = [
        {
          name: 'accounts',
          align: 'left',
          style: 'white-space:nowrap',
          label: this.$t('Accounts'),
          field: 'accounts',
          sortable: true,
        },
        {
          name: 'channels',
          align: 'left',
          style: 'white-space:nowrap',
          label: this.$t('Channels'),
          field: 'channels',
          sortable: true,
          headerStyle: 'white-space:nowrap',
        },
        {
          name: 'daily',
          align: 'center',
          style: 'white-space:nowrap',
          label: this.$t('Daily'),
          field: 'daily',
          sortable: true,
          headerStyle: 'white-space:nowrap',
        },
        {
          name: 'dailyRate',
          align: 'center',
          label: this.$t('Daily Rate'),
          field: 'dailyRate',
          style: 'white-space:nowrap',
          headerStyle: 'white-space:nowrap',
        },
        {
          name: 'monthly',
          align: 'center',
          label: this.$t('Monthly'),
          field: 'monthly',
          sortable: true,
          style: 'white-space:nowrap',
          headerStyle: 'white-space:nowrap',
        },
        {
          name: 'actions',
          label: this.$t('Actions'),
          required: true,
          align: 'center',
          style: 'width:80px;white-space:nowrap',
        },
      ];

      return columns;
    },
  },
  methods: {
    openModal(id) {
      this.$emit('openModal', id);
    },

    getAlert(id) {
      return this.alerts.find(alert => alert.id === id);
    },
  },
};
</script>

<style lang="scss" scoped></style>
